export default __webpack_public_path__ + "static/media/ic_cuba.e3c998f1.svg";